module.exports = __webpack_public_path__ + "img/kemampuan-menabung-active.c1fb2fd1.svg";